<div class="error">
  <hyperkit-typography *ngIf="error" variant="label2" color="error" >{{ error }}</hyperkit-typography>
</div>
